export default function (func, delay) {
    let inDebounce;
    return function (...args) {
        const context = this;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
}
